import { useTranslation } from 'react-i18next';

export const keyPrefix = 'departmentUserList';
export const useDepartmentUserListTranslation = () => useTranslation('widgets', { keyPrefix });
export const ruRu = ({
  [keyPrefix]: {
    title: 'Пользователи',
  },
}) as Record<string, unknown>;
export const en = ({
  [keyPrefix]: {
    title: 'Users',
  },
}) as Record<string, unknown>;
export const esEs = ({
  [keyPrefix]: {
    title: 'Usuários',
  },
}) as Record<string, unknown>;
export const ptBr = ({
  [keyPrefix]: {
    title: 'Usuarios',
  },
}) as Record<string, unknown>;
